export function eventScheduleSettings(value = {}) {
  const minutes = raw => raw === '' || raw == null ? null : Number(raw);
  return {bufferBeforeMinutes:minutes(value.bufferBeforeMinutes),bufferAfterMinutes:minutes(value.bufferAfterMinutes),
    eventBalanceOnlineEnabled:value.eventBalanceOnlineEnabled!==false,
    ...(['inherit','auto','manual'].includes(value.eventApprovalMode)?{eventApprovalMode:value.eventApprovalMode}:{}),
    ...(Array.isArray(value.eventResourceRequirements)?{eventResourceRequirements:value.eventResourceRequirements}:{}),
  };
}
